/** Prepare a local upload copy only; the source File and stored photo stay intact. */
export const PROFILE_PHOTO_LIMIT = 2_000_000;
const ALLOWED = ['image/jpeg', 'image/png', 'image/webp'];

async function decode(file) {
  if (typeof createImageBitmap === 'function') {
    try { return await createImageBitmap(file, {imageOrientation:'from-image'}); } catch {}
  }
  const url = URL.createObjectURL(file);
  try {
    return await new Promise((resolve,reject)=>{
      const image=new Image();image.onload=()=>resolve(image);image.onerror=()=>reject(new Error('This photo could not be opened. Choose another JPG, PNG, or WebP image.'));image.src=url;
    });
  } finally { URL.revokeObjectURL(url); }
}

export async function prepareProfilePhoto(file) {
  if (!ALLOWED.includes(file.type)) throw new Error('Choose a JPG, PNG, or WebP photo.');
  if (file.size <= PROFILE_PHOTO_LIMIT) return file;
  const image=await decode(file);
  try {
    const width=image.naturalWidth||image.width,height=image.naturalHeight||image.height;
    if (!width||!height) throw new Error('This photo could not be opened. Choose another image.');
    let scale=Math.min(1,2048/Math.max(width,height));
    for (let attempt=0;attempt<5;attempt++,scale*=0.75) {
      const canvas=document.createElement('canvas');
      canvas.width=Math.max(1,Math.round(width*scale));canvas.height=Math.max(1,Math.round(height*scale));
      const context=canvas.getContext('2d');
      if (!context) throw new Error('This browser could not prepare the photo. Please try another browser.');
      context.fillStyle='#fff';context.fillRect(0,0,canvas.width,canvas.height);
      context.drawImage(image,0,0,canvas.width,canvas.height);
      for (const quality of [0.9,0.8,0.7,0.6]) {
        const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/jpeg',quality));
        if (!blob) throw new Error('This browser could not prepare the photo. Please choose another image.');
        if (blob.size<=PROFILE_PHOTO_LIMIT) {
          return new File([blob],`${file.name.replace(/\.[^.]+$/,'')}-upload.jpg`,{type:blob.type,lastModified:file.lastModified});
        }
      }
    }
    throw new Error('This photo could not be prepared under 2 MB. Please choose another image.');
  } finally { image.close?.(); }
}
